import axios from 'axios';
import type { CfeDocument } from '../types/cfe';

/** A failed/malformed response must never be treated as an empty CFE list. */
export function parseCfeStatusResponse(response: unknown): CfeDocument[] {
  if (Array.isArray(response)) return response;
  if (response && typeof response === 'object') {
    const result = response as { success?: boolean; data?: unknown; message?: string };
    if (result.success === false) throw new Error(result.message || 'No se pudieron cargar los CFE');
    if (Array.isArray(result.data)) return result.data;
  }
  throw new Error('El servidor no devolvió una lista válida de CFE');
}

export function getCfeRequestError(error: unknown, fallback: string): string {
  if (axios.isAxiosError(error)) {
    const message = error.response?.data?.message;
    if (typeof message === 'string' && message.trim()) return message.trim();
    return error.response?.status
      ? `${fallback} (error ${error.response.status}). Revisá el registro de errores del servidor.`
      : `${fallback}. No se pudo conectar con el servidor.`;
  }
  return error instanceof Error ? error.message : fallback;
}

export function formatDgiReason(value: string | null | undefined): string | null {
  if (!value) return null;
  return value.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim() || null;
}

export function normalizeCfeMessage(value: string | null | undefined): string | null {
  if (value == null) return null;

  const trimmed = value.trim();
  if (!trimmed) return null;

  const normalized = trimmed.replace(',', '.');
  if (/^[.\-0\s]+$/.test(normalized)) {
    return null;
  }

  return trimmed;
}
